<template>
  <SectionFrame v-if="list.length || inStudio" :section="section" :index="index" :heading="heading" label="Accreditations">
    <ul v-if="list.length" :class="layout === 'list' ? 's2-acc-list' : 's2-acc-badges'" class="mo-stagger">
      <li v-for="a in list" :key="a.type_id" :class="layout === 'list' ? '' : 't-card'">
        <span class="s2-acc-mark" aria-hidden="true">✓</span>
        <span class="s2-acc-text">
          <b>{{ a.name }}</b>
          <span v-if="section.showNumbers !== false && a.number" class="s2-muted s2-small">No. {{ a.number }}</span>
        </span>
        <a v-if="section.showLinks !== false && a.register_url" :href="a.register_url" class="t-link s2-u s2-small" target="_blank" rel="noopener">
          Check the register<span class="s2-hp"> for {{ a.name }} (opens a new tab)</span></a>
      </li>
    </ul>
    <StudioGap v-else>Choose which qualifications show on your website (Jobs › Qualifications).</StudioGap>
  </SectionFrame>
</template>

<script setup>
import {computed} from "vue";
import SectionFrame from "./SectionFrame.vue";
import StudioGap from "./StudioGap.vue";
import {layoutOf, pickAccreditations} from "@/utils/sectionLogic.js";
import {studioMode} from "@/classes/previewBridge.js";

const props = defineProps({section: {type: Object, required: true}, index: {type: Number, default: 0}, data: {type: Object, default: () => ({})}});
const inStudio = computed(() => studioMode.value !== "off");
const layout = computed(() => layoutOf(props.section, ["badges", "list"]));
const heading = computed(() => props.section.heading ?? "Trusted and registered");
const list = computed(() => pickAccreditations(props.data.accreditations, props.section));
</script>

<style>
.s2-acc-badges { list-style: none; padding: 0; margin: 0; display: grid; gap: var(--t-gap); grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); }
.s2-acc-badges li { display: grid; grid-template-columns: auto 1fr; gap: .25rem .75rem; align-items: start; }
.s2-acc-badges li > a { grid-column: 2; }
.s2-acc-list { list-style: none; padding: 0; margin: 0; }
.s2-acc-list li { display: flex; flex-wrap: wrap; align-items: baseline; gap: .25rem 1rem; padding: .8rem 0; border-bottom: 1px solid var(--t-line); }
.s2-acc-mark { display: inline-flex; width: 2rem; height: 2rem; border-radius: 50%; align-items: center; justify-content: center; font-weight: 800;
  background: color-mix(in srgb, var(--t-accent) 14%, var(--t-surface)); color: var(--t-accent); }
.s2-acc-text { display: flex; flex-direction: column; }
.s2-acc-list .s2-acc-text { flex-direction: row; gap: .75rem; align-items: baseline; flex: 1; }
</style>
